import type { AppState } from "store/types";

export const getDynamicFormState = (state: AppState) =>
  state.legacy.ui.dynamicForm;
